import store from '@portal/reducers/createStore';
import * as Sentry from '@sentry/react';
import { enableOverdraft } from '@portal/config/app.json';

class OverdraftService {
  private static instance: OverdraftService;
  private overdraftAlertCallbacks: Array<(amount: number) => void> = [];

  public static getInstance(): OverdraftService {
    if (!OverdraftService.instance) {
      OverdraftService.instance = new OverdraftService();
    }
    return OverdraftService.instance;
  }

  public subscribe(callback: (amount: number) => void): () => void {
    this.overdraftAlertCallbacks.push(callback);

    return () => {
      this.overdraftAlertCallbacks = this.overdraftAlertCallbacks.filter(
        (cb) => cb !== callback
      );
    };
  }

  public checkOverdraftUsage(transactionAmount: number): boolean {
    if (!enableOverdraft) return false;

    const state = store.getState();
    const balance = state.account.balance;

    if (!balance || !balance.overdraft) {
      return false;
    }

    if (balance.overdraft == null || balance.overdraft === '') {
      return false;
    }

    const willUseOverdraft =
      transactionAmount < Number(balance?.overdraft) &&
      Number(balance?.overdraft) > 0 &&
      balance?.overdraft !== '0.00';

    if (willUseOverdraft) {
      const overdraftUsed =
        Number(transactionAmount) - Number(balance?.available ?? 0);
      this.notifyOverdraftUsage(overdraftUsed);
      return true;
    }

    return false;
  }

  private notifyOverdraftUsage(amount: number): void {
    this.overdraftAlertCallbacks.forEach((callback) => {
      try {
        callback(amount);
      } catch (error) {
        Sentry.captureException(error, {
          extra: { overdraftAmount: amount },
        });
      }
    });
  }

  public getOverdraftInfo() {
    return {
      monthlyInterest: 2.5,
      annualInterest: 34.5,
      cet: 45.2,
    };
  }

  public triggerOverdraftAlert(overdraftAmount: number): void {
    this.notifyOverdraftUsage(overdraftAmount);
  }
}

export default OverdraftService;
